import { render, staticRenderFns } from "./ContractBalance.vue?vue&type=template&id=3b1fd380&scoped=true"
import script from "./ContractBalance.vue?vue&type=script&lang=js"
export * from "./ContractBalance.vue?vue&type=script&lang=js"
import style0 from "./ContractBalance.vue?vue&type=style&index=0&id=3b1fd380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fd380",
  null
  
)

export default component.exports